import { HostWizard } from "../../../components/Wizard/Host";

export const WizardHostPage = () => {
  return <HostWizard />;
};
